export const showErrorAlert = (message?: string) => ({ type: 'SHOW_ERROR_ALERT', payload: { message } })

export const showPrimaryAlert = (message: string) => ({ type: 'SHOW_PRIMARY_ALERT', payload: { message } })

export const showSuccessAlert = (message?: string) => ({ type: 'SHOW_SUCCESS_ALERT', payload: { message } })

export const showWarningAlert = (message: string) => ({ type: 'SHOW_WARNING_ALERT', payload: { message } })

export const showNewVersionAlert = () => ({ type: 'SHOW_NEW_VERSION_ALERT', payload: {} })
